import { Datagrid, LongTextField, useFieldLabel } from "ra-friendsofbabba";
import {
  DateField,
  Empty,
  TextField,
  usePermissions,
  useTranslate,
} from "react-admin";
import React, { Fragment } from "react";

import Actions from "../component/list/Actions";
import DeleteButton from "./buttons/DeleteButton";
import EditButton from "./buttons/EditButton";
import { ExportMenuButton } from "../component/button";
import Filters from "./Filters";
import HelpBlock from "../component/HelpBlock";
import { List as RaList } from "react-admin";
import { UserField } from "../component/field";

const List = (props) => {
  const fieldLabel = useFieldLabel({ ...props });
  const { loaded, permissions } = usePermissions();
  const isAdmin = loaded && permissions(["admin"]);
  const additionalProps = isAdmin ? {} : { bulkActionButtons: false };
  const translate = useTranslate();
  return (
    <Fragment>
      <HelpBlock visibleFor={["tro"]} context="list" />
      <RaList
        {...props}
        {...additionalProps}
        filters={<Filters />}
        actions={
          <Actions canExport={false}>
            <ExportMenuButton choices={["xlsx"]} />
          </Actions>
        }
        sort={{ field: "UserBreaks.id", order: "ASC" }}
        exporter={false}
        empty={<Empty canCreate={isAdmin} />}
      >
        <Datagrid rowClick="edit">
          <TextField source="id" label="#ID" sortBy="UserBreaks.id" />
          <UserField
            label={fieldLabel("user_id")}
            source="user.name"
            sortBy="UserProfiles.name"
          />
          <TextField
            label={fieldLabel("user_break_reason_id")}
            source="user_break_reason.name"
            sortBy="UserBreakReasons.name"
          />
          <DateField
            source="start"
            emptyText={translate("ra.na")}
            sortBy="UserBreaks.start"
          />
          <DateField source="end" sortBy="UserBreaks.end" />
          <LongTextField source="description" sortable={false} />
          <EditButton />
          <DeleteButton />
        </Datagrid>
      </RaList>
    </Fragment>
  );
};
export default List;
